// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import store from "./store";
// 引入iview
import ViewUI from "view-design";
import "view-design/dist/styles/iview.css";
import "./assets/css/iveiw_new.css"; /*修改iview.css*/
import "./assets/css/common.css"; /*公共css*/
Vue.use(ViewUI);

// 引入element
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
Vue.use(ElementUI);

// 引入百度地图
// import BaiduMap from 'vue-baidu-map'

// Vue.use(BaiduMap, {
//   // ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key */
//   ak: 'hSEXtZiCvudIO2g7p6nPvMzglqZEay71'
// })

/* 引入配置 */
import Configure from "../configure";
Vue.prototype.configure = Configure;
// console.log(this.configure)

/*网络请求*/
import HttpRequest from "./assets/js/http.js";
Vue.prototype.http = HttpRequest;

/*全局组件*/
import Breadcrumb from "@/components/breadcrumb/index";
Vue.component("breadcrumb", Breadcrumb); /*面包屑导航*/
import Grid from "@/components/grid/grid";
Vue.component("grid", Grid); /*内容容器*/
import Prid from "@/components/page/page";
Vue.component("page", Prid); /*分页*/

/* 引入公共js */
import Tools from "./assets/js/tools.js";
Vue.prototype.tools = Tools;

/* 引入api接口 */
import api from "./assets/js/api.js";
Vue.prototype.API = api;

// 引入公共变量
import global from "@/components/global/global";
Vue.prototype.GLOBAL = global;

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js